import { render, staticRenderFns } from "./MyRecognition.vue?vue&type=template&id=1e4ae438&v-if=isLoggedIn&"
import script from "./MyRecognition.vue?vue&type=script&lang=js&"
export * from "./MyRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports